import { render, staticRenderFns } from "./ledgerContract.vue?vue&type=template&id=4dd73a30&scoped=true"
import script from "./ledgerContract.vue?vue&type=script&lang=js"
export * from "./ledgerContract.vue?vue&type=script&lang=js"
import style0 from "./ledgerContract.vue?vue&type=style&index=0&id=4dd73a30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd73a30",
  null
  
)

export default component.exports